module.exports = __webpack_public_path__ + "img/285.6efa1267.svg";